<template>
  <article class="">
    <cabeceraEN></cabeceraEN>
    <!-- <section class="portada">
      <div class="linea">

        <h1>Relaciones Institucionales</h1>
      </div>
    </section> -->
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Institutional Relations</h2>
    </section>
   <!--  <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section> -->
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>At COMPAÑIA MEGA S.A. we devote our best efforts to establish long-term and strong
relationships with our stakeholders in accordance with our Management Manual. For this
purpose, we have developed different community outreach programs. Our external
stakeholders include clients, suppliers, neighbors, surface rights owners, public and private
entities, nonprofit associations, NGOs, and the media, among others.</p>

            <h5>“Acompañando a Crecer” - Scholarship Program</h5>
            <p>
In 2003 MEGA S.A. launched a College Scholarship Program for Ingeniero White high-
school graduates. This program, which awards 5 scholarships every year, is run in close
collaboration with Foundation Cecilia Grierson, which provides assistance with scholarship
applications and assessments.</p>
            <h6>APPLICATION REQUIREMENTS</h6>
            <ul>
              <li><img  src="./check.png" alt="" >Graduating from a high school located in the district of Ingeniero White.</li>
              <li> <img  src="./check.png" alt="" >Pursue and complete undergraduate education in the city of Bahía Blanca.</li>
              <li> <img  src="./check.png" alt="" >Having a high-school grade point average of ≥ 8.</li>
              <li> <img  src="./check.png" alt="" >Not holding other scholarships or internships.</li>
            </ul>
            <a href="static/pdf/reglamento2021.docx">SEE SCHOLARSHIP RULES</a>
            <div class="cont-pdf">
              <img class="img" src="./becas2021.png" alt="" >

            </div>
          </div>
        </div>
      <!--   <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h5 class="subtitulo">Programa de Pasantías</h5>
            <p>Teniendo en cuenta la importancia de fomentar el vínculo con las universidades, la Compañía posee un Programa anual de pasantías rentadas para estudiantes universitarios con la Universidad Nacional del Sur (Bahía Blanca) y la Universidad Nacional del Comahue (Neuquén). Participan de dichas pasantías los alumnos que cursan carreras relacionadas con el proceso productivo, a los efectos de realizar tareas que les permitan mejorar su conocimiento en temas específicos y realizar sus tesis de estudio.</p>        
            <h5 class="subtitulo">Programa UNISOL</h5>
            <p>Es un programa solidario implementado a partir de una iniciativa del personal de la compañía quienes han conformado un grupo de ayuda llamado “Unisol”. El mismo tiene como fin recaudar dinero en forma mensual entre quienes desean colaborar voluntariamente, para ser donado con diferentes fines solidarios. Todos los meses, el grupo, a través de una votación, elige el destino del dinero recaudado (instituciones, tratamientos médicos, escuelas, etc.). Compañía Mega S.A. apoya a sus empleados, colaborando con este proyecto duplicando el monto del dinero recaudado y entregándolo a Unisol para que efectúe la donación correspondiente.</p>
            
            <h5 class="subtitulo">Participación en Instituciones</h5>
            <p>Como parte de su vínculo con otros organismos, Compañía Mega S.A. participa en las siguientes instituciones: Cámara de Concesionarios y Permisionarios del Puerto de Bahía Blanca, Instituto Argentino del Petróleo y Gas, Unión Industrial de Bahía Blanca, Instituto Petroquímico Argentino, FUNDECE (Fundación Empresaria para la Calidad y la Excelencia).</p>
          </div>
        </div> -->
        <div class="video">
          <h1>20 years Mega</h1>
          <div class="col-12 col-sm-12 col-md-10">
          <p style="text-align: center">On April 1, 2021 we turn 20 years old and to celebrate it we chose to tell our story in the voice of its protagonists. Past, present and future of the company in the testimonies of the people who are part of Mega's history and present. In 2001 we began our operation and our goal of adding value to energy to take it to different parts of the country, the region and the world.  #20AñosMega #LaVozDeNuestraHistoria #AgregamosValorALaEnergía</p>
        </div>
          <video controls playsinline src="./20anios.mp4"></video>
        </div>
      </div>
        <div class="banda-azul">
          <div class="texto">
            <h1>Follow the news and updates of our company in our Social Networks</h1>
           <div class="rrss">
             <a target="_blank" href="https://ar.linkedin.com/company/ciamega"> <img src="./in.png" alt=""></a>
            <a target="_blank" href="https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"> <img src="./yt.png" alt=""></a>
           </div>
          </div>
        </div>

    </section>
    <pieEN></pieEN>
  </article>
</template>

<script>
export default {
  name: 'relacionesInstitucionales',
  components: {
    CabeceraEN,
    PieEN
  }
}
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.secundario p 
  margin-bottom: 10px
.cont-pdf
  width: 100%
  display: flex
  justify-content: space-around
.img
  margin: 20px auto
  width: 70%
  -webkit-transition: all .35s ease-in-out
  -moz-transition: all .35s ease-in-out
  -o-transition: all .35s ease-in-out
  -ms-transition: all .35s ease-in-out
  transition: all .35s ease-in-out
  &:hover
    width: 90%
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
.link-azul
  display: block
  text-align: center
  color: #004D9E
h5 
  color: #323232
  font-size: 16px
h6
  color: #004d9e
  font-size: 16px
  text-transform: uppercase
ul 
  padding-left: 15px
  padding-bottom: 30px
  @media (max-width: 550px)
    padding: 30px 0
  li
    list-style: none
    display: flex
    align-items: flex-start
    img
      margin: 0
      margin-right: 5px
      margin-top: 5px
a 
  text-align: center
  padding: 7px 18px
  background: #004d9e
  color: #fff
  font-weight: 600
  margin-bottom: 30px
  margin-left: 184px
  @media (max-width: 550px)
    margin: 0
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.video
  padding: 40px 0
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    margin-top: 40px
    font-weight: 400
    position: relative
    z-index: 2
  div 
    z-index: 2
    position: relative
    p
      color: #fff
  video
    max-width: 960px
    position: relative
    z-index: 2
    width: 100%
.banda-azul
  background: #004d9e
  padding: 50px 0
  width: 100%
  .texto
    display: flex
    flex-direction: column
    align-items: center
    h1
      color: #fff
      font-size: 30px
      text-align: center
      font-weight: 400
      @media (max-width: 550px)
        font-size: 20px
    .rrss
      display: flex
      width: 100px
      a
        margin: 0
        padding: 0
</style>



// WEBPACK FOOTER //
// src/components/relaciones-institucionales-en/relacionesInstitucionales-en.vue